module.exports = "/_next/static/images/e23b0aaa310858d3dbbec5b100f2ba4e-woman-with-sandwich@3x.jpg.webp";